import { css } from '@linaria/core';
import theme from '../../../theme';

const paginationRoot = css`
  display: flex;
  gap: 4px;
  align-items: flex-end;
`;

const paginationItem = css`
  --pagination-size: 38px;
  --bg-pagination-item-active: ${theme.colors.primary[1]};
  user-select: none;
  display: inline-flex;
  justify-content: center;
  border-radius: 4px;
  align-items: center;
  min-width: var(--pagination-size);
  height: var(--pagination-size);
  text-decoration: none;
  color: inherit;
  border-width: 0px;
  border-color: transparent;

  &.mobile-hidden {
    display: none;
    @media screen and (min-width: ${theme.sizes.screens.sm}) {
      display: inline-flex;
    }
  }
  &:hover:not([disabled]) {
    background: ${theme.colors.neutral[10]};
    --bg-pagination-item-active: ${theme.colors.primary[1]};
  }

  &.active:not([disabled]) {
    background: var(--bg-pagination-item-active);
    color: white;
  }
  &[disabled] {
    color: ${theme.colors.neutral[50]};
    pointer-events: none;
  }
`;

export default {
  root: paginationRoot,
  item: paginationItem,
};
